import { useMerchantFeatures } from "@/hooks/use-merchant-features";

export const useIsAssurance = () => {
  const features = useMerchantFeatures();
  return features.includes("assurance");
};
